import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import type { GraphData } from '@services/MsGraphService'
import { callMsGraph } from '@services/MsGraphService'
import { createFileRoute } from '@tanstack/react-router'
import { loginRequest } from '@utils/authConfig.ts'
import { useEffect, useState } from 'react'

export const Route = createFileRoute('/forestowner/auth-test')({
  component: RouteComponent,
})

function RouteComponent() {
  const { instance, inProgress } = useMsal()
  const [graphData, setGraphData] = useState<null | GraphData>(null)

  useEffect(() => {
    if (!graphData && inProgress === InteractionStatus.None) {
      callMsGraph()
        .then((response) => {
          console.log('Returned', response)
          setGraphData(response)
        })
        .catch((e: unknown) => {
          if (e instanceof InteractionRequiredAuthError) {
            instance
              .acquireTokenRedirect({
                ...loginRequest,
                account: instance.getActiveAccount() ?? undefined,
              })
              .then((result) => {
                console.log('success', result)
              })
              .catch((e: unknown) => {
                console.log('error', e)
              })
          }
        })
    }
  }, [graphData, inProgress, instance.acquireTokenRedirect, instance.getActiveAccount])

  return (
    <>
      <p>{graphData?.displayName}</p>
      <p>{graphData?.jobTitle}</p>
      <p>{graphData?.mail}</p>
      <p>{graphData?.businessPhones[0]}</p>
      <p>{graphData?.officeLocation}</p>
    </>
  )
}
